import { getEnvironmentInfo, getApiBaseUrl } from '@/lib/environment';

// Environment configuration for API endpoints
export const API_CONFIG = {
  getApiUrl(path: string): string {
    // Remove leading slash if present to avoid double slashes
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;

    // Get environment info and base URL
    const env = getEnvironmentInfo();
    const baseUrl = getApiBaseUrl();

    // Build the full URL
    const fullUrl = `${baseUrl}/${cleanPath}`;

    // Remove any /api/api duplication in the final URL
    const fixedUrl = fullUrl.replace('/api/api/', '/api/');

    console.log('API_CONFIG Debug:', {
      originalPath: path,
      cleanPath,
      environment: env,
      baseUrl,
      fullUrl,
      fixedUrl
    });

    return fixedUrl;
  }
};